export default __webpack_public_path__ + "static/media/deselect_personalize.89935ace.svg";